// extracted by css-extract-rspack-plugin
export default {"container":"Wn9Yy","center":"hHpvG","img":"jlcVs","texts":"hkQFP","title":"ls6sp","text":"KMyZh","buttons":"ARfaN","button":"RaZmq"};